import { Routes, Route, Navigate, useParams, useNavigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';
import { useThemeStore } from './store/themeStore';
import { useEffect } from 'react';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import AdminDashboard from './pages/admin/Dashboard';
import AdminTenants from './pages/admin/Tenants';
import AdminVisualSettings from './pages/admin/VisualSettings';
import AdminPackages from './pages/admin/Packages';
import AdminFeedbackTickets from './pages/admin/FeedbackTickets';
import AdminErrors from './pages/admin/AdminErrors';
import AdminErrorDetail from './pages/admin/AdminErrorDetail';
import AdminDependencies from './pages/admin/Dependencies';
import TenantDashboard from './pages/tenant/Dashboard';
import TenantClients from './pages/tenant/Clients';
import ClientDetail from './pages/tenant/ClientDetail';
import TenantClientStatement from './pages/tenant/ClientStatement';
import ClientPortalStatement from './pages/client/ClientStatement';
import ClientAccount from './pages/client/ClientAccount';
import ClientMessages from './pages/client/ClientMessages';
import TenantClientPortalMessages from './pages/tenant/TenantClientPortalMessages';
import TenantInvoices from './pages/tenant/Invoices';
import InvoiceEditor from './pages/tenant/InvoiceEditor';
import InvoiceView from './pages/tenant/InvoiceView';
import InvoiceSend from './pages/tenant/InvoiceSend';
import TenantEstimates from './pages/tenant/Estimates';
import EstimateEditor from './pages/tenant/EstimateEditor';
import EstimateView from './pages/tenant/EstimateView';
import EstimateSend from './pages/tenant/EstimateSend';
import TenantSuppliers from './pages/tenant/Suppliers';
import SupplierDetail from './pages/tenant/SupplierDetail';
import TenantVehicles from './pages/tenant/TenantVehicles';
import VehicleDetail from './pages/tenant/VehicleDetail';
import TenantPurchases from './pages/tenant/Purchases';
import PurchaseEditor from './pages/tenant/PurchaseEditor';
import PurchaseAIUpload from './pages/tenant/PurchaseAIUpload';
import PurchaseAIReview from './pages/tenant/PurchaseAIReview';
import Banking from './pages/tenant/Banking';
import BankingAccountTransactions from './pages/tenant/BankingAccountTransactions';
import BankingAccountEditor from './pages/tenant/BankingAccountEditor';
import LoanAccountSetup from './pages/tenant/banking/LoanAccountSetup';
import ReconciliationImportWizard from './pages/tenant/banking/reconciliation/ImportWizard';
import ReconciliationHub from './pages/tenant/banking/reconciliation/Hub';
import ReconciliationAccountWorkbench from './pages/tenant/banking/reconciliation/AccountWorkbench';
import ReconciliationStatusReport from './pages/tenant/banking/reconciliation/StatusReport';
import ReconciliationMonthEndClose from './pages/tenant/banking/reconciliation/MonthEndClose';
import TransactionEditor from './pages/tenant/TransactionEditor';
import TenantReports from './pages/tenant/Reports';
import ChartOfAccounts from './pages/tenant/reports/ChartOfAccounts';
import JournalList from './pages/tenant/reports/JournalList';
import JournalEntryForm from './pages/tenant/reports/JournalEntryForm';
import AccountMapping from './pages/tenant/reports/AccountMapping';
import ProfitAndLoss from './pages/tenant/reports/ProfitAndLoss';
import BalanceSheet from './pages/tenant/reports/BalanceSheet';
import VATReturns from './pages/tenant/reports/VATReturns';
import TrialBalance from './pages/tenant/reports/TrialBalance';
import SegmentedProfitAndLoss from './pages/tenant/reports/SegmentedProfitAndLoss';
import ClientMonthlyBalance from './pages/tenant/reports/ClientMonthlyBalance';
import SupplierMonthlyBalance from './pages/tenant/reports/SupplierMonthlyBalance';
import DebtorCreditorReport from './pages/tenant/reports/DebtorCreditorReport';
import ClientAgeingReport from './pages/tenant/reports/ClientAgeingReport';
import SupplierAgeingReport from './pages/tenant/reports/SupplierAgeingReport';
import CashBasedProfitAndLoss from './pages/tenant/reports/CashBasedProfitAndLoss';
import TenantCertificates from './pages/tenant/Certificates';
import CertificateEditor from './pages/tenant/CertificateEditor';
import NewEicr from './pages/tenant/certification/NewEicr';
import NewEic from './pages/tenant/certification/NewEic';
import NewMewc from './pages/tenant/certification/NewMewc';
import TenantSettings from './pages/tenant/Settings';
import TenantUserManagement from './pages/tenant/UserManagement';
import Calculators from './pages/tenant/tools/Calculators';
import CableLimitingTempCalc from './pages/tenant/tools/calculators/CableLimitingTempCalc';
import CableSizeCalc from './pages/tenant/tools/calculators/CableSizeCalc';
import VoltDropACCalc from './pages/tenant/tools/calculators/VoltDropACCalc';
import VoltDropDCCalc from './pages/tenant/tools/calculators/VoltDropDCCalc';
import KVACalc from './pages/tenant/tools/calculators/KVACalc';
import OhmsLawCalc from './pages/tenant/tools/calculators/OhmsLawCalc';
import PFCCalc from './pages/tenant/tools/calculators/PFCCalc';
import RFCLineCPCRatioCalc from './pages/tenant/tools/calculators/RFCLineCPCRatioCalc';
import RFCR1R2Converter from './pages/tenant/tools/calculators/RFCR1R2Converter';
import MaxZsValues from './pages/tenant/tools/calculators/MaxZsValues';
import ZsCommonDevices from './pages/tenant/tools/calculators/ZsCommonDevices';
import WattAmpsVoltsCalc from './pages/tenant/tools/calculators/WattAmpsVoltsCalc';
import Design from './pages/tenant/tools/Design';
import PricingTools from './pages/tenant/tools/Pricing';
import WagoPriceList from './pages/tenant/tools/WagoPriceList';
import Planner from './pages/tenant/tools/Planner';
import MobileLayout from './components/MobileLayout';
import MobileHome from './pages/tenant/mobile/MobileHome';
import MobileMileage from './pages/tenant/mobile/MobileMileage';
import MobileReceipts from './pages/tenant/mobile/MobileReceipts';
import MobilePurchaseManualEntry from './pages/tenant/mobile/MobilePurchaseManualEntry';
import MobilePurchasePaymentPrompt from './pages/tenant/mobile/MobilePurchasePaymentPrompt';
import MobilePlanner from './pages/tenant/mobile/MobilePlanner';
import MobileCalculators from './pages/tenant/mobile/MobileCalculators';
import KnowledgeBase from './pages/tenant/tools/KnowledgeBase';
import RamsList from './pages/tenant/tools/RamsList';
import RamsEditor from './pages/tenant/tools/RamsEditor';
import RamsView from './pages/tenant/tools/RamsView';
import JobRamsList from './pages/tenant/jobs/JobRamsList';
import JobRamsNew from './pages/tenant/jobs/JobRamsNew';
import RamsRouteGuard from './components/RamsRouteGuard';
import ClientDashboard from './pages/client/Dashboard';
import ClientInvoices from './pages/client/Invoices';
import ClientEstimates from './pages/client/Estimates';
import ClientCertificates from './pages/client/Certificates';
import ClientOnboarding from './pages/client/ClientOnboarding';
import PortalLogon from './pages/client/PortalLogon';
import ClientPortalGate from './components/ClientPortalGate';
import PortalEntry from './pages/client/PortalEntry';
import Pay from './pages/client/Pay';
import PublicInvoiceView from './pages/portal/PublicInvoiceView';
import PublicEstimateView from './pages/portal/PublicEstimateView';
import PublicStatementView from './pages/portal/PublicStatementView';
import ImpersonationBanner from './components/ImpersonationBanner';
import Home from './pages/landing/Home';
import Features from './pages/landing/Features';
import Pricing from './pages/landing/Pricing';
import About from './pages/landing/About';
import SignUp from './pages/landing/SignUp';
import SignUpSuccess from './pages/landing/SignUpSuccess';
import TenantOnboarding from './pages/TenantOnboarding';
import { estimatesAPI } from './api';

/** Converts estimate to invoice with the next invoice number; opens the new invoice editor. */
function TenantEstimateConvertRedirect() {
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const result = await estimatesAPI.convertToInvoice(id, null, null);
        const newInvoiceId = result?.invoiceId ?? result?.invoice?.id;
        if (!newInvoiceId) throw new Error('Convert succeeded but no invoice id was returned');
        if (!cancelled) navigate(`/tenant/invoices/${newInvoiceId}/edit`, { replace: true });
      } catch (e) {
        const msg = e.response?.data?.error || e.message || 'Failed to convert estimate';
        if (!cancelled) {
          alert(msg);
          navigate(`/tenant/estimates/${id}`, { replace: true });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [id, navigate]);
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4">
      <div className="inline-block h-8 w-8 animate-spin rounded-full border-2 border-[var(--ds-accent-primary)] border-t-transparent" />
      <p className="mt-4 text-sm text-[var(--ds-text-secondary)]">Creating invoice from estimate…</p>
    </div>
  );
}

function App() {
  const { isAuthenticated, checkTokenExpiry } = useAuthStore();
  const { initTheme } = useThemeStore();

  // Clear expired token on app mount (handles long-idle tabs)
  useEffect(() => {
    checkTokenExpiry?.();
  }, [checkTokenExpiry]);

  // Initialize theme on app mount
  useEffect(() => {
    initTheme();
  }, [initTheme]);

  return (
    <div className="min-h-screen bg-background">
      <ImpersonationBanner />
      <Routes>
        {/* Landing pages */}
        <Route path="/" element={<Home />} />
        <Route path="/features" element={<Features />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/signup/success" element={<SignUpSuccess />} />
        
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/onboarding" element={<TenantOnboarding />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/:portalSlug/logon" element={<PortalLogon />} />
        <Route path="/portal/invoice/:token" element={<PublicInvoiceView />} />
        <Route path="/portal/estimate/:token" element={<PublicEstimateView />} />
        <Route path="/portal/statement/:token" element={<PublicStatementView />} />
        <Route path="/client/portal-entry" element={<PortalEntry />} />
        <Route path="/client/pay" element={<Pay />} />
        
        {/* Protected routes - Global Admin */}
        <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute allowedRoles={['global_admin']}>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/visual-settings" 
          element={
            <ProtectedRoute allowedRoles={['global_admin']}>
              <AdminVisualSettings />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/tenants" 
          element={
            <ProtectedRoute allowedRoles={['global_admin']}>
              <AdminTenants />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/packages" 
          element={
            <ProtectedRoute allowedRoles={['global_admin']}>
              <AdminPackages />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/feedback" 
          element={
            <ProtectedRoute allowedRoles={['global_admin']}>
              <AdminFeedbackTickets />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/errors" 
          element={
            <ProtectedRoute allowedRoles={['global_admin']}>
              <AdminErrors />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/errors/:id" 
          element={
            <ProtectedRoute allowedRoles={['global_admin']}>
              <AdminErrorDetail />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/dependencies" 
          element={
            <ProtectedRoute allowedRoles={['global_admin']}>
              <AdminDependencies />
            </ProtectedRoute>
          } 
        />
        
        {/* Protected routes - Tenant */}
        <Route 
          path="/tenant/dashboard" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantDashboard />
            </ProtectedRoute>
          } 
        />
        {/* Mobile WebView shell — deep-linked from native apps; not linked from sidebar/dashboard */}
        <Route
          path="/tenant/mobile"
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <MobileLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<MobileHome />} />
          <Route path="mileage" element={<MobileMileage />} />
          <Route path="receipts" element={<MobileReceipts />} />
          <Route path="receipts/manual-entry" element={<MobilePurchaseManualEntry />} />
          <Route path="receipts/payment-prompt" element={<MobilePurchasePaymentPrompt />} />
          <Route path="planner" element={<MobilePlanner />} />
          <Route path="calculators" element={<MobileCalculators />} />
          <Route path="calculators/cable-limiting-temperature" element={<CableLimitingTempCalc />} />
          <Route path="calculators/max-zs-values" element={<MaxZsValues />} />
          <Route path="calculators/max-zs-values/zs-common-devices" element={<ZsCommonDevices />} />
          <Route path="calculators/cable-size" element={<CableSizeCalc />} />
          <Route path="calculators/kva-calc" element={<KVACalc />} />
          <Route path="calculators/ohms-law" element={<OhmsLawCalc />} />
          <Route path="calculators/pfc-calc" element={<PFCCalc />} />
          <Route path="calculators/rfc-line-cpc-ratio" element={<RFCLineCPCRatioCalc />} />
          <Route path="calculators/rfc-r1-r2-converter" element={<RFCR1R2Converter />} />
          <Route path="calculators/voltage-drop-ac" element={<VoltDropACCalc />} />
          <Route path="calculators/voltage-drop-dc" element={<VoltDropDCCalc />} />
          <Route path="calculators/watt-amps-volts" element={<WattAmpsVoltsCalc />} />
          <Route path="*" element={<Navigate to="/tenant/mobile" replace />} />
        </Route>
        <Route 
          path="/tenant/clients" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantClients />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/clients/:id/statement" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantClientStatement />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/client-portal-messages" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantClientPortalMessages />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/clients/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ClientDetail />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/invoices" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantInvoices />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/invoices/new" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <InvoiceEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/invoices/:id/view" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <InvoiceView />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/invoices/:id/send" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <InvoiceSend />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/invoices/:id/edit" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <InvoiceEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/invoices/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <InvoiceEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/estimates" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantEstimates />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/estimates/new" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <EstimateEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/estimates/convert" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <Navigate to="/tenant/estimates" replace />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/estimates/:id/view" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <EstimateView />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/estimates/:id/send" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <EstimateSend />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/estimates/:id/convert" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantEstimateConvertRedirect />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/estimates/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <EstimateEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/suppliers" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantSuppliers />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/suppliers/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <SupplierDetail />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/vehicles" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantVehicles />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/vehicles/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <VehicleDetail />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/purchases" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantPurchases />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/purchases/new" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <PurchaseEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/purchases/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <PurchaseEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/purchases/ai-upload" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <PurchaseAIUpload />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/purchases/ai-review" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <PurchaseAIReview />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/banking" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <Banking />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantReports />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/accounts" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ChartOfAccounts />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/accounts/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ChartOfAccounts />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/journals" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <JournalList />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/journals/new" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <JournalEntryForm />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/journals/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <JournalList />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/account-mapping" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <AccountMapping />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/profit-loss" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ProfitAndLoss />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/balance-sheet" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <BalanceSheet />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/vat-returns" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <VATReturns />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/trial-balance" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TrialBalance />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/segmented-pl" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <SegmentedProfitAndLoss />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/client-monthly-balance" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ClientMonthlyBalance />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/supplier-monthly-balance" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <SupplierMonthlyBalance />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/debtor-creditor" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <DebtorCreditorReport />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/client-ageing" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ClientAgeingReport />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/supplier-ageing" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <SupplierAgeingReport />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/reports/cash-based-pl" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <CashBasedProfitAndLoss />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/settings" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TenantSettings />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/tenant/users"
          element={
            <ProtectedRoute allowedRoles={['tenant_admin']}>
              <TenantUserManagement />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/tenant/tools/calculators" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <Calculators />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/cable-limiting-temperature" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <CableLimitingTempCalc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/max-zs-values" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <MaxZsValues />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/max-zs-values/zs-common-devices" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ZsCommonDevices />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/cable-size" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <CableSizeCalc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/kva-calc" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <KVACalc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/ohms-law" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <OhmsLawCalc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/pfc-calc" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <PFCCalc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/rfc-line-cpc-ratio" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <RFCLineCPCRatioCalc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/rfc-r1-r2-converter" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <RFCR1R2Converter />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/voltage-drop-ac" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <VoltDropACCalc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/voltage-drop-dc" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <VoltDropDCCalc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/calculators/watt-amps-volts" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <WattAmpsVoltsCalc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/design" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <Design />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/pricing" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <PricingTools />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/planner" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <Planner />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/tenant/tools/knowledge-base"
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <KnowledgeBase />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/tenant/tools/pricing/wago-price-list" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <WagoPriceList />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/rams" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <RamsRouteGuard>
                <RamsList />
              </RamsRouteGuard>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/rams/new" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <RamsRouteGuard>
                <RamsEditor />
              </RamsRouteGuard>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/rams/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <RamsRouteGuard>
                <RamsView />
              </RamsRouteGuard>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/tools/rams/:id/edit" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <RamsRouteGuard>
                <RamsEditor />
              </RamsRouteGuard>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/jobs/:jobId/rams" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <RamsRouteGuard>
                <JobRamsList />
              </RamsRouteGuard>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/jobs/:jobId/rams/new" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <RamsRouteGuard>
                <JobRamsNew />
              </RamsRouteGuard>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/certification" element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']} requireCertificateAccess={true}>
              <TenantCertificates />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/certification/newEicr/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']} requireCertificateAccess={true}>
              <NewEicr />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/certification/newEicr" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']} requireCertificateAccess={true}>
              <NewEicr />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/certification/newEic/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']} requireCertificateAccess={true}>
              <NewEic />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/certification/newEic" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']} requireCertificateAccess={true}>
              <NewEic />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/certification/newEic/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']} requireCertificateAccess={true}>
              <NewEic />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/certification/newMewc" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']} requireCertificateAccess={true}>
              <NewMewc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/certification/newMewc/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']} requireCertificateAccess={true}>
              <NewMewc />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/certification/new" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']} requireCertificateAccess={true}>
              <CertificateEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/certification/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']} requireCertificateAccess={true}>
              <CertificateEditor />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/tenant/banking/reconciliation"
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ReconciliationHub />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tenant/banking/reconciliation/accounts/:id"
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ReconciliationAccountWorkbench />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tenant/banking/reconciliation/import"
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ReconciliationImportWizard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tenant/banking/reconciliation/accounts/:accountId/import"
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ReconciliationImportWizard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tenant/banking/reconciliation/status-report"
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ReconciliationStatusReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tenant/banking/reconciliation/accounts/:accountId/close"
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <ReconciliationMonthEndClose />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/tenant/banking/accounts/new" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <BankingAccountEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/banking/accounts/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <BankingAccountEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/banking/accounts/:id/transactions" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <BankingAccountTransactions />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/tenant/banking/accounts/:id/loan"
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <LoanAccountSetup />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/tenant/banking/transactions/new" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TransactionEditor />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/tenant/banking/transactions/:id" 
          element={
            <ProtectedRoute allowedRoles={['tenant_admin', 'tenant_user']}>
              <TransactionEditor />
            </ProtectedRoute>
          } 
        />
        
        {/* Protected routes - Client Portal */}
        <Route
          path="/client"
          element={
            <ProtectedRoute allowedRoles={['client']}>
              <ClientPortalGate />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/client/dashboard" replace />} />
          <Route path="onboarding" element={<ClientOnboarding />} />
          <Route path="dashboard" element={<ClientDashboard />} />
          <Route path="invoices" element={<ClientInvoices />} />
          <Route path="estimates" element={<ClientEstimates />} />
          <Route path="certificates" element={<ClientCertificates />} />
          <Route path="statement" element={<ClientPortalStatement />} />
          <Route path="account" element={<ClientAccount />} />
          <Route path="messages" element={<ClientMessages />} />
        </Route>
        
        {/* Authenticated redirects - handled by ProtectedRoute */}
        
        {/* 404 */}
        <Route path="*" element={<div className="flex items-center justify-center min-h-screen"><h1 className="text-4xl font-bold">404 - Page Not Found</h1></div>} />
      </Routes>
    </div>
  );
}

export default App;

